import { ModuleFE_RuntimeFinding } from '@app/advisor-frontend';
import { FindingType_Enumerated, FindingType_Numeric } from '@app/advisor-shared';
import { exists, StaticLogger } from '@nu-art/ts-common';
const getFindingInstances = (currentFindings, previousFindings, updatedFinding) => {
    const existingFinding = ModuleFE_RuntimeFinding.cache.unique(updatedFinding._id);
    const previousFinding = (existingFinding && !existingFinding.isPartialCalculation)
        ? previousFindings.toUpdate.find(ftu => ftu.findingId === updatedFinding._id)
        : previousFindings.toCreate.find(prf => prf.variableId === updatedFinding.variableId);
    if (!previousFinding) {
        StaticLogger.logWarning('Got finding to supplement that is not in context!', 'Response Finding', updatedFinding, 'Existing Finding', existingFinding);
        return;
    }
    const currentFinding = (existingFinding && !existingFinding.isPartialCalculation)
        ? currentFindings.toUpdate.find(ftu => ftu.findingId === updatedFinding._id)
        : currentFindings.toCreate.find(prf => prf.variableId === updatedFinding.variableId);
    const bornFromImplicitAccept = exists(currentFinding) && 'suggestedFinding' in currentFinding && !currentFinding.suggestedFinding?.userInteracted;
    return {
        existingFinding,
        previousFinding,
        currentFinding,
        bornFromImplicitAccept
    };
};
/**
 * This function supplements the previous context data with the data from the current context + the response we get from EM simulation.
 * @param currentFindings
 * @param previousFindings
 * @param emResponse
 */
export const supplementPreviousContextFindings = (currentFindings, previousFindings, emResponse) => {
    emResponse.updated.forEach(updatedFinding => {
        const instances = getFindingInstances(currentFindings, previousFindings, updatedFinding);
        if (!instances)
            return;
        const { currentFinding, previousFinding } = instances;
        //Retain general calculated data
        previousFinding.isPartialCalculation = updatedFinding.isPartialCalculation;
        previousFinding.source = updatedFinding.source.type;
        //Retain suggested finding status
        if (currentFinding && 'suggestedFinding' in currentFinding) {
            previousFinding.suggestedFinding = currentFinding.suggestedFinding;
        }
        //Update value
        switch (updatedFinding.type) {
            case FindingType_Numeric: {
                const _toUpdate = previousFinding;
                _toUpdate.value = updatedFinding.value;
                break;
            }
            case FindingType_Enumerated: {
                const _toUpdate = previousFinding;
                _toUpdate.valueIds = updatedFinding.valueIds;
                //Set attribute values from response in the context
                updatedFinding.attributes?.forEach(att => {
                    const attToUpdate = _toUpdate.attributes?.find(i => i.variableId === att.variableId);
                    if (!attToUpdate)
                        return StaticLogger.logWarning('Got Attribute to supplement that is not in the context!', updatedFinding, att);
                    attToUpdate.valueIds = att.valueIds;
                });
                //Remove values from attributes in the context if they did not appear in the response
                _toUpdate.attributes?.forEach(att => {
                    if (!updatedFinding.attributes?.find(item => item.variableId === att.variableId))
                        att.valueIds = [];
                });
            }
        }
    });
};
//# sourceMappingURL=data-supplementing.js.map